/**
 * Certains navigateurs / OS laissent file.type vide (ex. WebP sous Windows).
 * On complète la détection MIME par l’extension.
 */
export function isLikelyImageFile(file) {
  if (!file) return false;
  if (file.type && file.type.startsWith('image/')) return true;
  return /\.(jpe?g|png|gif|webp|avif|bmp|heic)$/i.test(file.name || '');
}
